"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styled_1 = __importDefault(require("@emotion/styled"));
var hooks_1 = require("./hooks");
function TableOfContents(_a) {
  var renderLink = _a.renderLink,
    items = _a.items,
    _b = _a.scrollspy,
    scrollspy = _b === void 0 ? false : _b;
  var ids = [];
  // Iterate the ids and add to a watch array
  function pushItem(item) {
    var _a;
    if ((_a = item.url) === null || _a === void 0 ? void 0 : _a.startsWith('#')) {
      ids.push(item.url.replace('#', ''));
    }
    if (item.items) {
      item.items.forEach(pushItem);
    }
  }
  // Only watch if the user provides a root element to watch...
  if (scrollspy) {
    items.forEach(pushItem);
  }
  var active = hooks_1.useScrollSpy(ids, !!scrollspy);
  return react_1.default.createElement("ul", {
    className: "overflow-x-hidden text-base"
  }, items.map(function (item) {
    return react_1.default.createElement(RecursiveListItem, __assign({}, item, {
      depth: 1,
      renderLink: renderLink,
      active: active
    }));
  }));
}
exports.TableOfContents = TableOfContents;
var ListItem = styled_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: transform 0.2s, color 0.2s;\n\n  &:hover {\n    transform: translateX(5px);\n  }\n"], ["\n  transition: transform 0.2s, color 0.2s;\n\n  &:hover {\n    transform: translateX(5px);\n  }\n"])));
function RecursiveListItem(_a) {
  var renderLink = _a.renderLink,
    depth = _a.depth,
    url = _a.url,
    title = _a.title,
    items = _a.items,
    active = _a.active;
  var className = classnames_1.default('hover:text-gray-900 text-gray-600 dark-hover:text-gray-500', {
    'mt-2': depth === 1,
    'pl-2 text-sm': depth === 2,
    'pl-4 text-xs': depth === 3,
    'pl-6 text-xs': depth === 4,
    'pl-7 text-xs': depth >= 5,
    'font-extrabold': "#" + active === url
  });
  var link = renderLink(url, title);
  return react_1.default.createElement(react_1.default.Fragment, {
    key: url + depth
  }, !!url && react_1.default.createElement(ListItem, {
    className: className,
    "data-depth": depth
  }, react_1.default.cloneElement(link, {
    className: 'block py-1 truncate'
  })), !!items && items.map(function (l) {
    return react_1.default.createElement(RecursiveListItem, __assign({}, l, {
      depth: depth + 1,
      renderLink: renderLink,
      active: active
    }));
  }));
}
var templateObject_1;